<template>
  <div class="o-forgot-password">
    <app-navigation :currentSpace="$t('web.reset_password.nav_space')"></app-navigation>


    <main class="o-forgot-password__main">
      <section class="c-card js-reset-validation-shake">
        <form>
          <div class="c-card__header">
             <h2 class="c-card__title t-headline">{{ $t('web.reset_password.card_header') }}</h2>
          </div>


          <div class="c-card__body">
            <div v-if="error_message" class="c-form-validation t-alert-danger">
              {{ error_message }}
            </div>
            <div v-if="is_password_expired && !error_message" class="c-form-validation t-alert-info">
              {{ $t('web.reset_password.expired_password') }}
            </div>


            <fieldset class="o-fieldset">
              <label class="u-label" for="password">{{ $t('web.reset_password.new_password_label') }}</label>

              <ul class="u-tiny-list">
                <li>{{ $t('web.reset_password.new_password_minimum_12_characters') }}</li>
                <li>{{ $t('web.reset_password.new_password_minimum_1_number') }}</li>
                <li>{{ $t('web.reset_password.new_password_minimum_1_symbol') }}</li>
                <li>{{ $t('web.reset_password.new_password_minimum_1_uppercase') }}</li>
              </ul>

              <input
                v-model     = "request.password"
                id          = "password"
                type        = "password"
                placeholder = ""
                required
              />

              <div
                v-if  = "errors.password"
                class = "c-validation t-alert-danger"
                for   = "password"
              >
                {{ errors.password[0] }}
              </div>
            </fieldset>


            <fieldset class="o-fieldset">
              <label class="u-label" for="password_confirmation">
                {{ $t('web.reset_password.confirm_new_password_label') }}
              </label>

              <input
                v-model     = "request.password_confirmation"
                id          = "password_confirmation"
                type        = "password"
                placeholder = ""
                required
              />

              <div
                v-if  = "errors.password_confirmation"
                class = "c-validation t-alert-danger"
                for   = "password_confirmation"
              >
                {{ errors.password_confirmation[0] }}
              </div>
            </fieldset>
          </div>


          <div class="c-card__footer">
            <router-link
              v-if  ="!is_password_expired"
              :to   ="{name: 'Login'}"
              class ="c-card__footer__text-link u-tiny-note u-float-left t-link"
            >
              {{ $t('web.reset_password.login_link') }}
            </router-link>

            <button
              @click = "submit($event)"
              class  = "c-button u-float-right t-button-primary"
            >
              {{ is_password_expired ? $t('web.settings.save_button') : $t('web.reset_password.save_and_login') }}
            </button>
          </div>
        </form>
      </section>
    </main>


    <app-footer></app-footer>
  </div>
</template>




<script>
import $ from 'jquery'
import validate from 'validate.js'
import util from '@/functions'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'reset-password',
  data () {
    return {
      request: {
        primary_email: null,
        password: null,
        password_confirmation: null,
        token: null,
        platform_id: null
      },
      errors: {
        password: null,
        password_confirmation: null
      },
      error_message: '',
      is_password_expired: false
    }
  },

  computed: {
    ...mapGetters({
      appName: 'appName',
      websiteConfig: 'websiteConfig'
    })
  },

  mounted () {
    util.showPassword($('#password'))
    util.showPassword($('#password_confirmation'))
    this.initValidation()

    this.is_password_expired = this.$route.name === 'ExpiredPassword'
  },

  methods: {
    ...mapActions([
      'RESET_PASSWORD',
      'RESET_EXPIRED_PASSWORD',
      'LOGIN',
      'WEBSITE_CONFIG_AUTH_UPDATE',
      'LOAD_PARTICIPANT'
    ]),

    submit (e) {
      e.preventDefault()

      if (this.request.password !== this.request.password_confirmation) {
        this.error_message = this.$t('web.reset_password.validation_same_password')
        util.highlight('password')
        util.highlight('password_confirmation')
        return
      }

      let errors = this.validate()

      if (errors) {
        this.errors = errors
        if (this.errors.password) {
          $('#password').addClass('is-not-valid')
        }
        if (this.errors.password_confirmation) {
          $('#password_confirmation').addClass('is-not-valid')
        }
        util.shake($('.js-reset-validation-shake'))
        return
      }

      if (this.errors.password || this.errors.password_confirmation) {
        return
      }

      if (this.is_password_expired) {
        this.postResetExpiredPassword()
        return
      }

      this.postResetPassword()
    },

    postResetPassword () {
      this.request.platform_id = this.websiteConfig.id
      this.request.token = this.$route.params.token
      this.request.primary_email = this.$route.params.email
      var _self = this
      this.RESET_PASSWORD(this.request)
        .then(resp => {
          _self.error_message = ''
          _self.errors = { password: null, password_confirmation: null }
          switch (resp.data) {
            case 'passwords.reset':
              let request = {
                grant_type: 'password',
                username: _self.request.primary_email,
                password: _self.request.password,
                platform_id: _self.request.platform_id,
                scope: ''
              }
              this.LOGIN(request)
                .then(resp => {
                  this.WEBSITE_CONFIG_AUTH_UPDATE(this.$router).then(() => {
                    this.$router.push({ name: 'Dashboard' })
                    return
                  })
                })
                .catch(() => {
                  this.$router.push({ name: 'Login' })
                  return
                })
              break
            case 'passwords.token':
              this.error_message = this.$t('web.reset_password.reset_link_expired')
              break
            case 'password.inactive':
              this.error_message = this.$t('web.reset_password.account_inactive')
              break
          }
        })
        .catch((error) => {
          this.showRequestError(error)
          return
        })
    },

    postResetExpiredPassword () {
      this.RESET_EXPIRED_PASSWORD(this.request)
        .then(resp => {
          this.LOAD_PARTICIPANT(this.$router)
            .then(() => {
              this.$router.push({ name: 'Dashboard' })
            })
        })
        .catch((error) => {
          this.showRequestError(error)
        })
    },

    showRequestError (error) {
      util.shake($('.js-reset-validation-shake'))
      this.error_message = error.response.data.message
    },

    validate () {
      const constraints = {
        password: {
          presence: {
            message: this.$t('utils.validation.required')
              .replace('{attribute}', validate.capitalize(validate.prettify('password')))
          }
        },
        password_confirmation: {
          presence: {
            message: this.$t('utils.validation.required')
              .replace('{attribute}', validate.capitalize(validate.prettify('password_confirmation')))
          }
        }
      }
      return validate(this.request, constraints, {fullMessages: false})
    },

    initValidation () {
      let _self = this
      $('#password').on('blur', function (e) {
        if (!util.validatePassword($(this).val())) {
          _self.errors.password = [_self.$t('web.reset_password.validation_new_password_requirements')]
          $(this).addClass('is-not-valid')
        }
      }).focus(function (e) {
        _self.errors.password = null
        $(this).removeClass('is-not-valid')
      })
      $('#password_confirmation').on('blur', function (e) {
        e.preventDefault()
        if (!util.validatePassword($(this).val())) {
          _self.errors.password_confirmation = [_self.$t('web.reset_password.validation_new_password_requirements')]
          $(this).addClass('is-not-valid')
        }
      }).focus(function () {
        _self.errors.password_confirmation = null
        $(this).removeClass('is-not-valid')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ResetPassword.vue?d8621fd0